import type { AuthModalMode } from '~/stores/useAuthModal'

const VALID_MODES: AuthModalMode[] = ['login', 'register']

// Only allow same-origin path redirects to avoid open-redirect via `?redirect=`
function safeRedirect(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined
  if (!value.startsWith('/') || value.startsWith('//') || value.startsWith('/\\')) return undefined
  return value
}

export default defineNuxtPlugin(() => {
  const route = useRoute()
  const router = useRouter()

  watch (() => route.query.auth, (newVal) => {
      if (newVal && VALID_MODES.includes(newVal as AuthModalMode)) {
        const authModal = useAuthModal()
        const redirect = safeRedirect(route.query.redirect)
        authModal.open({
          mode: newVal as AuthModalMode,
          onSuccess: redirect ? () => navigateTo(redirect) : undefined,
        })

        const { auth, redirect: _redirect, ...rest } = route.query
        router.replace({ path: route.path, query: rest, hash: route.hash })
      }
  }, { immediate: true })
})
